export default {
  title: "Programme d'avis Google",
  sections: {
    google_review_settings: "Paramètres du programme d'avis Google",
  },
  form: {
    reward: {
      label: 'Récompense (points)',
      point_value: '100 points = {{moneyValue}}',
    },
    has_end_date: {
      label: 'Durée',
      options: {
        false: 'Illimitée',
        true: 'Avec une date de fin spécifique',
      },
    },
    end_date: {
      label: 'Date de fin',
    },
  },
  tags: {
    inactive: 'Inactif',
    active: 'Actif',
    expired: 'Expiré',
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    changes_got_saved: 'Modifications enregistrées',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
  },
};
